import UserStore from "../../store/user-store";
import {WgBanner} from "../VpnActive/WarningBanner/WgBanner";
import {AnimatePresence, motion} from "framer-motion";
import {VpnSettingsSelector} from "./VpnSettingsSelector";
import {ServerSelectorBtn} from "./ServerSelectorBtn";
import {ServerSelector} from "./ServerSelector";
import React, {useEffect, useState} from "react";
import {useHaptic} from "../../Hooks/useHaptic";
import ConfigStore from "../../store/config-store";
import {CopyTunnel} from "./ProModeUI/CopyTunnel";
import {QrCodeEx} from "./ProModeUI/ShowQrCode";
import {DownloadConfig} from "./ProModeUI/DownloadConfig";
import styled from "styled-components";
import {OpenInApp} from "./ProModeUI/OpenInApp";
import {toJS} from "mobx";
import {observer} from "mobx-react-lite";
import {useCreateConfig} from "../../Hooks/Api/useCreateConfig";
import {PushWalletConnect} from "../Notification/PushWalletConnect";
import { TG_WEB_APP } from "../../App";

const transportIcon = <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32" fill="none">
    <path
        d="M14.6667 29.3332V22.6665C14.6667 21.4221 14.4778 20.4998 14.1 19.8998C13.7222 19.2998 13.2222 18.7109 12.6 18.1332L14.5 16.2332C14.7667 16.4776 15.0222 16.7389 15.2667 17.0172C15.5111 17.2954 15.7556 17.5896 16 17.8998C16.3111 17.4776 16.628 17.1056 16.9507 16.7838C17.2733 16.4621 17.6009 16.1452 17.9333 15.8332C18.7778 15.0554 19.5444 14.1554 20.2333 13.1332C20.9222 12.1109 21.2889 10.3221 21.3333 7.7665L19.2333 9.8665L17.3333 7.99984L22.6667 2.6665L28 7.99984L26.1333 9.8665L24 7.7665C23.9556 10.9443 23.4667 13.2056 22.5333 14.5505C21.6 15.8954 20.6667 16.9896 19.7333 17.8332C19.0222 18.4776 18.4444 19.1056 18 19.7172C17.5556 20.3287 17.3333 21.3118 17.3333 22.6665V29.3332H14.6667ZM8.26667 10.8998C8.17778 10.4554 8.11689 9.9665 8.084 9.43317C8.05111 8.89984 8.02311 8.34428 8 7.7665L5.86667 9.8665L4 7.99984L9.33333 2.6665L14.6667 7.99984L12.7667 9.8665L10.6667 7.79984C10.6667 8.2665 10.6889 8.70561 10.7333 9.11717C10.7778 9.52873 10.8222 9.91184 10.8667 10.2665L8.26667 10.8998ZM11.1333 16.7665C10.6889 16.2998 10.2613 15.7554 9.85067 15.1332C9.44 14.5109 9.07867 13.7443 8.76667 12.8332L11.3333 12.1998C11.5556 12.7998 11.8111 13.3109 12.1 13.7332C12.3889 14.1554 12.7 14.5332 13.0333 14.8665L11.1333 16.7665Z"
        fill="white"/>
</svg>
const securityIcon = <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32" fill="none">
    <path
        d="M15.9997 29.3332C12.9108 28.5554 10.3606 26.7829 8.34901 24.0158C6.33745 21.2487 5.33212 18.1767 5.33301 14.7998V6.6665L15.9997 2.6665L26.6663 6.6665V14.7998C26.6663 18.1776 25.661 21.2501 23.6503 24.0172C21.6397 26.7843 19.0895 28.5563 15.9997 29.3332ZM15.9997 26.5332C18.1552 25.8665 19.9552 24.5496 21.3997 22.5825C22.8441 20.6154 23.6886 18.4212 23.933 15.9998H15.9997V5.49984L7.99968 8.49984V15.3998C7.99968 15.5554 8.0219 15.7554 8.06634 15.9998H15.9997V26.5332Z"
        fill="white"/>
</svg>

export const UIButtons = styled.button`
    padding: 17px;
    border-radius: 8px;
    background-color: #232425;
    border: 1px solid #38393A;
    font-size: 16px;
    text-align: center;
    font-weight: 500;
    max-height: 56px;
    display: flex;
    align-items: center;
    justify-content: center;
`

const ConfigDescBtn = styled.div`
    padding: 8px;
    border-radius: 6px;
    background-color: #232425;
    font-weight: 500;
    font-size: 14px;
    width: min-content;

`

const SettingsContainer = (
    {
        isCollapsed,
        setIsCollapsed,
        title,
        children,
    }
) => {
    const {hapticFeedBack} = useHaptic("select");
    return (
        <>
            <div
                style={{
                    display: "flex",
                    flexDirection: "column",
                    borderRadius: 12,
                    gap: 16,
                    border: "1px solid rgba(255, 255, 255, 0.15)",
                    overflow: "hidden",

                }}
            >
                <div
                    style={{
                        padding: "12px 16px",
                        borderBottom: isCollapsed ? "" : "1px solid rgba(255, 255, 255, 0.15)",
                        backgroundColor: "#131313",
                        display: "flex",
                        alignItems: "center",
                        cursor: "pointer",
                        justifyContent: "space-between",

                    }}
                    onClick={() => {
                        hapticFeedBack()
                        setIsCollapsed(!isCollapsed)
                    }}
                >
                    <h3 style={{fontSize: 20}}>
                        {title}
                    </h3>
                    <motion.button
                        animate={{rotate: isCollapsed ? 180 : 0}}
                        transition={{duration: 0.3}}
                        style={{
                            background: "none",
                            border: "none",
                            cursor: "pointer",
                            padding: "8px",
                            borderRadius: "8px",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                        }}
                    >
                        <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
                            <path
                                d="M5 7.5L10 12.5L15 7.5"
                                stroke="white"
                                strokeWidth="2"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                            />
                        </svg>
                    </motion.button>
                </div>

                <AnimatePresence>
                    {!isCollapsed && (
                        <motion.div
                            initial={{height: 0, opacity: 0}}
                            animate={{height: "auto", opacity: 1}}
                            exit={{height: 0, opacity: 0}}
                            transition={{duration: 0.3, ease: "easeInOut"}}
                            style={{overflow: "hidden"}}
                        >
                            <div
                                style={{
                                    display: "flex",
                                    flexDirection: "column",
                                    padding: "0px 12px 12px 12px",
                                    gap: 16,
                                }}
                            >
                                {children}
                            </div>
                        </motion.div>
                    )}
                </AnimatePresence>
            </div>
        </>
    )
}


function getOS() {
    const e = navigator.userAgent;
    return /android/i.test(e) ? {
        user_agent: e,
        app_platform: "android",
        real_platform: "Android"
    } : /iPad|iPhone|iPod/i.test(e) && !window.MSStream ? {
        user_agent: e,
        app_platform: "ios",
        real_platform: "IOS"
    } : /Mac/i.test(e) ? {
        user_agent: e,
        app_platform: "ios",
        real_platform: "MacOS"
    } : /Win/i.test(e) ? {
        user_agent: e,
        app_platform: "win",
        real_platform: "Windows"
    } : {
        user_agent: e,
        app_platform: "other",
        real_platform: "Other"
    }
}


export const ProMode = observer((
    {
        servers,
    }
) => {

    const [activeServerId, setActiveServer] = useState(2);
    const [showServerSelector, setShowServerSelector] = useState(false);
    const [activeProtocol, setActiveProtocol] = useState(1);
    const [activeTransport, setActiveTransport] = useState(1);
    const [activeSecurity, setActiveSecurity] = useState(1);

    const [isCfgSettingsCollapsed, setIsCfgSettingsCollapsed] = useState(false);
    const [isCfgResultCollapsed, setIsCfgResultCollapsed] = useState(true);

    const [showQrCodePortal, setShowQrCodePortal] = useState(false);

    const [platform, setPlatform] = useState();

    const [activeConfig, setActiveConfig] = useState();

    const {isLoading: isConfigLoading, isSuccess, createConfig} = useCreateConfig(activeProtocol, activeServerId)
    const [isConfigNotification, setIsConfigNotification] = useState(false);

    useEffect(() => {
        TG_WEB_APP.setHeaderColor('#ff8c00');
        return () => {
            TG_WEB_APP.setHeaderColor('#000000');
        }
    }, [])

    useEffect(() => {
        if ( isSuccess && !isConfigLoading) {
            setIsConfigNotification(true)
        }

        setTimeout(() => {
            setIsConfigNotification(false)
        }, 2200)
    }, [isConfigLoading]);

    const isRu = UserStore.langCode === "ru";
    const {hapticFeedBack} = useHaptic("select");

    useEffect(() => {
        const platform = getOS()
        setPlatform(platform.real_platform)
    }, [])


    useEffect(() => {
        const server = ConfigStore.configs.find(el => String(el.server_id) === String(activeServerId));
        const config = server?.configs?.[String(activeProtocol)];
        setActiveConfig(config)
    }, [activeServerId, activeProtocol, ConfigStore.configs, isConfigLoading])


    const vlessSecurity = {
        id: 3,
        title: isRu ? "безопасность" : "security",
        bottomSheetTitle: isRu ? "безопасности" : "security",
        activeItem: activeSecurity,
        items: [
            {
                id: 1,
                title: "Reality",
                description: isRu ? "Лучший метод обфускации" : "Best obfuscation method",
                isSoon: false,
                icon: securityIcon,
                setActiveItem: () => setActiveSecurity(1),
            },
            {
                id: 2,
                title: "TLS",
                description: isRu ? "Криптографический протокол": "Cryptographic protocol",
                setActiveItem: () => setActiveTransport(2),
                icon: securityIcon,
                isSoon: true,
            },
            {
                id: 3,
                title: "None",
                setActiveItem: () => setActiveTransport(3),
                icon: securityIcon,
                isSoon: true,
            },
        ]
    }
    const ProModeItems = [
            {
                id: 1,
                title: isRu ? "VPN протокол" : "protocol",
                bottomSheetTitle: isRu ? "протокла" : "protocol",
                activeItem: activeProtocol,
                items: [
                    {
                        id: 1,
                        title: "Vless",
                        description: isRu ? "проктол с обфускацией" : "obfuscated protocol",
                        setActiveItem: () => setActiveProtocol(1),
                        icon: (
                            <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width={32}
                                height={32}
                                viewBox="0 0 32 32"
                                fill="none"
                            >
                                <g clipPath="url(#clip0_1539_39997)">
                                    <mask
                                        id="mask0_1539_39997"
                                        style={{
                                            maskType: "alpha",
                                        }}
                                        maskUnits="userSpaceOnUse"
                                        x={0}
                                        y={0}
                                        width={32}
                                        height={32}
                                    >
                                        <path
                                            d="M27.4286 0H4.57143C2.0467 0 0 2.0467 0 4.57143V27.4286C0 29.9533 2.0467 32 4.57143 32H27.4286C29.9533 32 32 29.9533 32 27.4286V4.57143C32 2.0467 29.9533 0 27.4286 0Z"
                                            fill="#D9D9D9"
                                        />
                                    </mask>
                                    <g mask="url(#mask0_1539_39997)">
                                        <path
                                            d="M32 32H16L32 16V32ZM32 16L7.5 23.5L11 27L32 16L13.5 29.5L16 32H0V16L4 12L32 16ZM0 16L4 20L32 16H0ZM32 16L7.5 8.5L11 5L32 16ZM32 16L13.5 2.5L16 0L32 16Z"
                                            fill="white"
                                        />
                                    </g>
                                </g>
                                <defs>
                                    <clipPath id="clip0_1539_39997">
                                        <rect width={32} height={32} rx={5.33333} fill="white"/>
                                    </clipPath>
                                </defs>
                            </svg>
                        ),
                        isSoon:
                            false,
                    },
                    {
                        id: 2,
                        title:
                            "WireGuard",
                        setActiveItem:
                            () => setActiveProtocol(2),
                        description: isRu ? "протокол без обхода блокировок" : "protocol without bypassing blocks",
                        icon:
                            (
                                <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="32"
                                    height="32"
                                    viewBox="0 0 32 32"
                                    fill="none"
                                >
                                    <path
                                        fillRule="evenodd"
                                        clipRule="evenodd"
                                        d="M32 16C32 24.8366 24.8366 32 16 32C7.16344 32 0 24.8366 0 16C0 7.16344 7.16344 0 16 0C24.8366 0 32 7.16344 32 16ZM19.3627 12.6229C17.9694 9.94493 14.2507 8.85655 11.34 10.6373C7.59788 12.9267 7.81804 18.1857 11.2447 20.2813C11.5082 20.4423 11.627 20.4235 11.8001 20.19C12.3319 19.4761 13.0114 18.8851 13.7922 18.4573C13.9193 18.3864 14.0483 18.319 14.195 18.2423C14.2698 18.2032 14.3491 18.1618 14.4351 18.1162C12.7307 17.8207 11.8197 17.0427 11.714 15.842C11.6003 14.5496 12.2313 13.4981 13.3834 13.0606C13.9128 12.8674 14.4906 12.8518 15.0296 13.0161C15.5687 13.1803 16.0395 13.5155 16.3712 13.9712C16.5826 14.2602 16.7311 14.5904 16.8069 14.9404C16.8829 15.2905 16.8845 15.6525 16.8116 16.0032C16.6719 16.7432 16.2327 17.2788 15.6811 17.7511C17.5524 17.3132 18.9157 16.2823 19.4931 14.4441C19.6603 13.9117 19.6267 13.1303 19.3627 12.6229ZM7.64177 23.9425C8.02168 23.8112 8.3944 23.6823 8.77528 23.5857C9.16162 23.4876 9.55594 23.4212 9.96436 23.3523C10.147 23.3215 10.3325 23.2903 10.5214 23.2555C10.5738 22.3499 10.8848 21.4785 11.4176 20.7446C9.57857 20.5495 7.40391 22.2598 7.12866 24.1168C7.30202 24.0599 7.47261 24.001 7.64177 23.9425ZM21.4221 5.47008C21.1106 5.46789 20.7992 5.4657 20.4881 5.45427C20.4219 5.45182 20.3574 5.40445 20.2929 5.35704C20.263 5.3351 20.2332 5.31316 20.2031 5.29566C20.2348 5.28306 20.2665 5.26709 20.2982 5.25112C20.3664 5.21672 20.4346 5.18233 20.5031 5.18168C21.231 5.17484 21.959 5.17547 22.6873 5.17609C22.8984 5.17628 23.1095 5.17646 23.3207 5.17646C23.3217 4.68791 22.6688 4.01896 22.0887 3.83768C22.0871 3.86237 22.0855 3.88642 22.084 3.91027C22.0813 3.95032 22.0787 3.98984 22.0761 4.03098C21.4997 4.04467 20.9339 4.03394 20.42 3.76063C20.3274 3.71138 20.2567 3.6209 20.186 3.53039C20.1534 3.48857 20.1207 3.44675 20.0859 3.40898C20.0428 3.36223 20.002 3.31131 19.9613 3.26039C19.871 3.14747 19.7807 3.03452 19.6642 2.96686C19.4395 2.83646 19.2015 2.72931 18.9633 2.6221C18.8338 2.56383 18.7044 2.50555 18.577 2.4435C17.2913 1.81725 15.9336 1.83927 14.4751 1.9728L16.9216 2.54223L16.8947 2.68584C16.1753 2.78222 15.4825 2.63258 14.7874 2.48244C14.4648 2.41276 14.1417 2.34298 13.8153 2.29763C14.1849 2.51713 14.5662 2.71647 14.9574 2.89481C15.2334 3.01864 15.5154 3.12918 15.7991 3.24045C15.9236 3.28925 16.0484 3.33819 16.1732 3.38845C15.6531 3.83285 15.1312 3.93036 14.4774 3.78098C14.1171 3.69576 13.747 3.6597 13.377 3.67377C12.9865 3.68401 12.6063 3.80163 12.2782 4.0137C12.3854 4.06808 12.4902 4.11974 12.5928 4.17031C12.8408 4.29253 13.0757 4.40835 13.3011 4.54051C13.4325 4.61757 13.5832 4.74839 13.6198 4.88334C13.6932 5.21228 13.7479 5.54514 13.7834 5.88029C13.1833 5.94826 12.1281 6.5586 11.9148 6.95578C12.2165 7.01383 12.5269 7.02993 12.8389 7.04611C13.4808 7.07938 14.1291 7.113 14.7212 7.51298C14.5706 7.62697 14.316 7.7554 14.0714 7.87876C13.8453 7.99277 13.6278 8.10246 13.5089 8.19244C13.815 8.27263 14.5242 8.23337 14.8016 8.21456C15.0352 8.19873 15.1429 8.19302 15.2387 8.27182L17.9538 10.3975C18.2393 10.6277 19.3924 11.7191 19.6933 12.4052C19.8645 12.7841 19.962 13.192 19.9809 13.6074C19.9815 14.0874 19.892 14.5634 19.717 15.0104C19.6231 15.249 19.3474 15.7776 18.7787 16.3938C17.8972 17.3487 16.7634 17.8649 15.5234 18.1205C12.6404 18.715 10.2449 21.7939 10.9211 25.1881C11.7106 29.1508 16.0844 31.2963 19.6586 29.4113C21.9689 28.1929 23.1937 25.8159 22.8656 23.2283C22.6672 21.6651 21.96 20.3901 20.7746 19.3651C20.6196 19.2312 20.5214 19.2312 20.3397 19.3475C19.7217 19.742 19.092 20.1157 18.4507 20.4687C18.2014 20.6058 17.9381 20.7175 17.6507 20.8393C17.5142 20.8972 17.3722 20.9574 17.2237 21.0237C17.2845 21.0394 17.3332 21.0519 17.3745 21.0625C17.4405 21.0795 17.4873 21.0915 17.5341 21.104C19.2578 21.5626 20.1786 23.0758 19.7707 24.7706C19.408 26.2779 17.8779 27.2415 16.395 26.9873C15.1589 26.7755 14.0797 25.749 13.8995 24.5189C13.7031 23.1785 14.3707 21.8892 15.5584 21.3491C15.8742 21.2055 16.1941 21.0709 16.514 20.9362C16.8614 20.79 17.2088 20.6437 17.5511 20.486C17.7483 20.3952 17.9498 20.3094 18.1515 20.2235C18.7141 19.9839 19.2785 19.7434 19.7588 19.3908C21.378 18.2017 22.378 16.5645 22.7679 14.5885C23.0014 13.4048 22.9856 12.2263 22.4441 11.1024C22.0285 10.2399 21.3465 9.61329 20.6138 9.04151C20.2503 8.75779 19.8764 8.48718 19.5026 8.21659C19.1011 7.92601 18.6997 7.63543 18.311 7.32863C18.1079 7.16829 17.9709 6.89183 17.8769 6.64113C17.8369 6.5349 17.9665 6.24681 18.0532 6.23124C18.5156 6.15116 18.983 6.10343 19.452 6.08841C19.8775 6.07234 20.304 6.07965 20.7303 6.08696C20.8455 6.08893 20.9607 6.09091 21.0759 6.09242C21.0956 6.09268 21.1166 6.09246 21.1381 6.09224C21.2442 6.09115 21.3639 6.08992 21.4199 6.14504C21.7003 6.4207 21.9202 6.24338 22.1148 6.06204C22.2664 5.89837 22.4038 5.72212 22.5256 5.53519C22.3924 5.50667 22.2574 5.48786 22.1214 5.47888C21.8884 5.47336 21.6552 5.47172 21.4221 5.47008Z"
                                        fill="white"
                                    />
                                </svg>
                            ),
                        isSoon:
                            false,
                    }
                    ,
                    {
                        id: 3,
                        title:
                            "Vmess",
                        setActiveItem:
                            () => setActiveProtocol(3),
                        icon:
                            (
                                <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width={32}
                                    height={32}
                                    viewBox="0 0 32 32"
                                >
                                    <path
                                        fill="#fff"
                                        d="M16 2a14 14 0 1 0 14 14A14 14 0 0 0 16 2m11.3 10h-5.64a22.5 22.5 0 0 0-2.705-7.616A12.03 12.03 0 0 1 27.3 12M20 16c0 .693-.037 1.357-.094 2h-7.811A22 22 0 0 1 12 16c0-.693.037-1.357.094-2h7.811c.058.643.095 1.307.095 2m-4 12c-.115 0-.226-.014-.34-.017A20.4 20.4 0 0 1 12.368 20h7.264a20.4 20.4 0 0 1-3.292 7.983c-.114.003-.225.017-.34.017m-3.632-16a20.4 20.4 0 0 1 3.292-7.983c.114-.003.225-.017.34-.017s.226.014.34.017A20.4 20.4 0 0 1 19.632 12Zm.683-7.618A22.4 22.4 0 0 0 10.339 12H4.7a12.03 12.03 0 0 1 8.35-7.618ZM4.18 14h5.91c-.052.647-.091 1.307-.091 2s.039 1.353.091 2H4.18a11.2 11.2 0 0 1 0-4m.52 6h5.638a22.4 22.4 0 0 0 2.712 7.618A12.03 12.03 0 0 1 4.7 20m14.255 7.616A22.5 22.5 0 0 0 21.661 20H27.3a12.03 12.03 0 0 1-8.344 7.616ZM27.819 18h-5.91c.052-.647.091-1.307.091-2s-.039-1.353-.091-2h5.91a11.2 11.2 0 0 1 0 4"
                                    ></path>
                                </svg>
                            ),
                        isSoon:
                            true,
                    }
                    ,
                    {
                        id: 4,
                        title:
                            "HTTPUpgrade",
                        setActiveItem:
                            () => setActiveProtocol(4),
                        icon:
                            (
                                <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width={32}
                                    height={32}
                                    viewBox="0 0 32 32"
                                >
                                    <path
                                        fill="#fff"
                                        d="M16 2a14 14 0 1 0 14 14A14 14 0 0 0 16 2m11.3 10h-5.64a22.5 22.5 0 0 0-2.705-7.616A12.03 12.03 0 0 1 27.3 12M20 16c0 .693-.037 1.357-.094 2h-7.811A22 22 0 0 1 12 16c0-.693.037-1.357.094-2h7.811c.058.643.095 1.307.095 2m-4 12c-.115 0-.226-.014-.34-.017A20.4 20.4 0 0 1 12.368 20h7.264a20.4 20.4 0 0 1-3.292 7.983c-.114.003-.225.017-.34.017m-3.632-16a20.4 20.4 0 0 1 3.292-7.983c.114-.003.225-.017.34-.017s.226.014.34.017A20.4 20.4 0 0 1 19.632 12Zm.683-7.618A22.4 22.4 0 0 0 10.339 12H4.7a12.03 12.03 0 0 1 8.35-7.618ZM4.18 14h5.91c-.052.647-.091 1.307-.091 2s.039 1.353.091 2H4.18a11.2 11.2 0 0 1 0-4m.52 6h5.638a22.4 22.4 0 0 0 2.712 7.618A12.03 12.03 0 0 1 4.7 20m14.255 7.616A22.5 22.5 0 0 0 21.661 20H27.3a12.03 12.03 0 0 1-8.344 7.616ZM27.819 18h-5.91c.052-.647.091-1.307.091-2s-.039-1.353-.091-2h5.91a11.2 11.2 0 0 1 0 4"
                                    ></path>
                                </svg>
                            ),
                        isSoon:
                            true,
                    }
                    ,
                    {
                        id: 5,
                        title:
                            "XHTTP",
                        setActiveItem:
                            () => setActiveProtocol(5),
                        icon:
                            (
                                <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width={32}
                                    height={32}
                                    viewBox="0 0 32 32"
                                >
                                    <path
                                        fill="#fff"
                                        d="M16 2a14 14 0 1 0 14 14A14 14 0 0 0 16 2m11.3 10h-5.64a22.5 22.5 0 0 0-2.705-7.616A12.03 12.03 0 0 1 27.3 12M20 16c0 .693-.037 1.357-.094 2h-7.811A22 22 0 0 1 12 16c0-.693.037-1.357.094-2h7.811c.058.643.095 1.307.095 2m-4 12c-.115 0-.226-.014-.34-.017A20.4 20.4 0 0 1 12.368 20h7.264a20.4 20.4 0 0 1-3.292 7.983c-.114.003-.225.017-.34.017m-3.632-16a20.4 20.4 0 0 1 3.292-7.983c.114-.003.225-.017.34-.017s.226.014.34.017A20.4 20.4 0 0 1 19.632 12Zm.683-7.618A22.4 22.4 0 0 0 10.339 12H4.7a12.03 12.03 0 0 1 8.35-7.618ZM4.18 14h5.91c-.052.647-.091 1.307-.091 2s.039 1.353.091 2H4.18a11.2 11.2 0 0 1 0-4m.52 6h5.638a22.4 22.4 0 0 0 2.712 7.618A12.03 12.03 0 0 1 4.7 20m14.255 7.616A22.5 22.5 0 0 0 21.661 20H27.3a12.03 12.03 0 0 1-8.344 7.616ZM27.819 18h-5.91c.052-.647.091-1.307.091-2s-.039-1.353-.091-2h5.91a11.2 11.2 0 0 1 0 4"
                                    ></path>
                                </svg>
                            ),
                        isSoon:
                            true,
                    }
                    ,
                    {
                        id: 6,
                        title:
                            "OpenVPN",
                        setActiveItem:
                            () => setActiveProtocol(6),
                        icon:
                            (
                                <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width={32}
                                    height={32}
                                    viewBox="0 0 32 32"
                                >
                                    <path
                                        fill="#fff"
                                        d="M16 2a14 14 0 1 0 14 14A14 14 0 0 0 16 2m11.3 10h-5.64a22.5 22.5 0 0 0-2.705-7.616A12.03 12.03 0 0 1 27.3 12M20 16c0 .693-.037 1.357-.094 2h-7.811A22 22 0 0 1 12 16c0-.693.037-1.357.094-2h7.811c.058.643.095 1.307.095 2m-4 12c-.115 0-.226-.014-.34-.017A20.4 20.4 0 0 1 12.368 20h7.264a20.4 20.4 0 0 1-3.292 7.983c-.114.003-.225.017-.34.017m-3.632-16a20.4 20.4 0 0 1 3.292-7.983c.114-.003.225-.017.34-.017s.226.014.34.017A20.4 20.4 0 0 1 19.632 12Zm.683-7.618A22.4 22.4 0 0 0 10.339 12H4.7a12.03 12.03 0 0 1 8.35-7.618ZM4.18 14h5.91c-.052.647-.091 1.307-.091 2s.039 1.353.091 2H4.18a11.2 11.2 0 0 1 0-4m.52 6h5.638a22.4 22.4 0 0 0 2.712 7.618A12.03 12.03 0 0 1 4.7 20m14.255 7.616A22.5 22.5 0 0 0 21.661 20H27.3a12.03 12.03 0 0 1-8.344 7.616ZM27.819 18h-5.91c.052-.647.091-1.307.091-2s-.039-1.353-.091-2h5.91a11.2 11.2 0 0 1 0 4"
                                    ></path>
                                </svg>
                            ),
                        isSoon:
                            true,
                    }
                ],
            },
            {
                id: 2,
                title: isRu ? " трансопрт" : "transport",
                bottomSheetTitle: isRu ? " транспорта" : "transport",
                activeItem:
                activeTransport,
                items:
                    [
                        {
                            id: 1,
                            title: "TCP",
                            isSoon: false,
                            icon: transportIcon,
                            setActiveItem: () => setActiveTransport(1),
                        },
                        {
                            id: 2,
                            title: "gRPC",
                            setActiveItem: () => setActiveTransport(2),
                            icon: transportIcon,
                            isSoon: true,
                        },
                        {
                            id: 3,
                            title: "WebSocket",
                            setActiveItem: () => setActiveTransport(3),
                            icon: transportIcon,
                            isSoon: true,
                        },
                        {
                            id: 4,
                            title: "mKCP",
                            setActiveItem: () => setActiveTransport(4),
                            icon: transportIcon,
                            isSoon: true,
                        },
                    ],
            }
            ,

        ];

    let items = [...ProModeItems];

    if (activeProtocol === 1) {
        items.push(vlessSecurity);
    }

    const setActiveServerHandler = (serverId) => {
        setActiveServer(serverId);
        hapticFeedBack();
        setShowServerSelector(false);
    };


    return (
        <>
            {UserStore.langCode === "ru" && <WgBanner/>}
            {isConfigNotification  && <PushWalletConnect push_text={"Config generated"}/>}
            <SettingsContainer
                isCollapsed={isCfgSettingsCollapsed}
                setIsCollapsed={setIsCfgSettingsCollapsed}
                title={isRu ? "Настройка конфигурации" : "Configuration settings"}
            >
                {items.map((item, index) => (
                    <motion.div
                        key={index}
                        initial={{opacity: 0, y: 10}}
                        animate={{opacity: 1, y: 0}}
                        transition={{duration: 0.3}}
                    >
                        <VpnSettingsSelector
                            title={item.title}
                            bottomSheetTitle={item.bottomSheetTitle}
                            items={item.items}
                            activeItemId={item.activeItem}
                        />
                    </motion.div>
                ))}
                <div>
                    <h4
                        style={{
                            marginBottom: 12,
                            fontSize: 16,
                            fontWeight: 400,
                        }}
                    >
                        {isRu ? "Выберите сервер" : "Chose server"}
                    </h4>
                        <ServerSelectorBtn
                            servers={servers}
                            activeServerId={activeServerId}
                            setShowServerSelector={setShowServerSelector}
                        />
                </div>
            </SettingsContainer>
            <AnimatePresence>
                {showServerSelector && (
                    <ServerSelector
                        servers={servers}
                        activeServerId={activeServerId}
                        setShowServerSelector={setShowServerSelector}
                        setActiveServer={setActiveServerHandler}
                    />
                )}
            </AnimatePresence>
            <SettingsContainer
                isCollapsed={isCfgResultCollapsed}
                setIsCollapsed={setIsCfgResultCollapsed}
                title={isRu ? "Ваша конфигурация" : "Yours configuration"}
            >
                {activeConfig ?
                    <>
                        <CopyTunnel
                            config={activeConfig}
                            isRu={isRu}
                        />
                        <div style={{
                            display: "flex",
                            gap: 10
                        }}>
                            <QrCodeEx
                                showQrCodePortal={showQrCodePortal}
                                setShowQrCodePortal={setShowQrCodePortal}
                                config={activeConfig}
                            />

                            <DownloadConfig
                                protocolId={activeProtocol}
                                config={activeConfig}
                            />
                        </div>

                        {activeProtocol === 1 &&
                            <OpenInApp
                                isRu={isRu}
                                platform={platform}
                                config={activeConfig}
                            />}

                    </> :
                    <AnimatedUIButton
                        disabled={isConfigLoading}
                        isLoading={isConfigLoading}
                        onClick={() => {
                            createConfig()
                            hapticFeedBack()
                        }}
                    >{isRu ? "Сгенерировать конфигурацию" : "Generate tunnel"}</AnimatedUIButton>
                }

            </SettingsContainer>
        </>
    )
})

const AnimatedUIButton = ({ isLoading, children, ...props }) => (
  <UIButtons {...props} style={{ position: "relative", overflow: "hidden" }}>
    {isLoading && (
      <motion.div
        initial={{ width: 0 }}
        animate={{ width: "100%" }}
        exit={{ width: 0 }}
        transition={{ duration: 1.2, ease: "easeInOut" }}
        style={{
          position: "absolute",
          left: 0,
          top: 0,
          bottom: 0,
          background: "linear-gradient(90deg, #444 0%, #232425 100%)",
          zIndex: 1,
          borderRadius: 8,
        }}
      />
    )}
    <span style={{ position: "relative", zIndex: 2, display: "flex", alignItems: "center" }}>
      {children}
      {isLoading && (
        <span style={{ marginLeft: 8, display: "flex", alignItems: "center" }}>
          <svg width="20" height="20" viewBox="0 0 50 50">
            <circle
              cx="25"
              cy="25"
              r="20"
              fill="none"
              stroke="#fff"
              strokeWidth="4"
              strokeDasharray="31.4 31.4"
              strokeLinecap="round"
              transform="rotate(-90 25 25)"
            >
              <animateTransform
                attributeName="transform"
                type="rotate"
                from="0 25 25"
                to="360 25 25"
                dur="1s"
                repeatCount="indefinite"
              />
            </circle>
          </svg>
        </span>
      )}
    </span>
  </UIButtons>
);